(function($, Drupal){
    Drupal.behaviors.RatesServicesAjaxLoad = {
        attach: function (context, settings) {
          var cookieCity = Cookies.get("radiocity");
          var cookieType = Cookies.get("radiotype");
          var cookieCityName = Cookies.get("radiocityName");
          var cookieTypeName = Cookies.get("radiotypeName");
    
          $('#tax' + cookieCity).attr('checked', 'checked');
          $('#tax' + cookieType).attr('checked', 'checked');
    
          $('input:radio[name="Locations"]').filter('[value="' + cookieCity + '"]').attr('checked', true);
          $('input:radio[name="ServiceType"]').filter('[value="' + cookieType + '"]').attr('checked', true);
    
          if (cookieCity && cookieType) {
            $(".radio-accordion .accordion-title span.location").text(": " + cookieCityName);
            $(".radio-accordion .accordion-title span.service").text(": " + cookieTypeName);
            $('#load-content', context).load('/rates-services/' + cookieCity + '/' + cookieType + ' .ajax-content', function () {
              $(document).foundation();
              $(".title-wrapper .title-section button", context).on("click", function () {
                $('.popup').hide('fast');
                $(this).next(".popup").toggle();
              });
              $(".rate-accordion").on("down.zf.accordion", function (e) {
                var thisheight = $('.accordion-content', this).height();
                if (thisheight > 50) {
                  $('html, body').animate({
                    scrollTop: ($('.is-active .accordion-content', this).offset().top - 125)
                  }, 100);
                }
              });
              if ($(window).width() <= 1024) {
                $(".path-rates-service-charges .field-paragraph--field-text").prepend('<div class="mobile-rate-title"><h1>Rates & Services Charges</h1><p class="rate-bread">' + cookieCityName + ' > ' + cookieTypeName + '</p></div>');
              } else {
                $("#load-content").prepend('<h1>Rates & Services Charges</h1><p class="rate-bread">' + cookieCityName + ' > ' + cookieTypeName + '</p>');
              }
            });
          }
    
          $('#location-form', context).change(function () {
            var cookie = Cookies.get("radiotype");
            var cookieTypeName = Cookies.get("radiotypeName");
            var city = $("input[name='Locations']:checked").val();
            var cityID = $("input[name='Locations']:checked").attr('id');
            var cityName = $("label[for='tax" + city + "']").text();
            Cookies.set('radiocity', city, {
              expires: 1,
              sameSite: 'secure'
            });
            Cookies.set('radiocityName', cityName, {
              expires: 1,
              sameSite: 'secure'
            });
            if (cookie) {
              $('#load-content').load('/rates-services/' + cookie + '/' + city + ' .ajax-content', function () {
                $(document).foundation();
                $(".radio-accordion .accordion-title span.location").text(": " + cityName);
                $(".title-wrapper .title-section button", context).on("click", function () {
                  $('.popup').hide('fast');
                  $(this).next(".popup").toggle();
                });
                $(".rate-accordion").on("down.zf.accordion", function (e) {
                  var thisheight = $('.accordion-content', this).height();
                  if (thisheight > 50) {
                    $('html, body').animate({
                      scrollTop: ($('.is-active .accordion-content', this).offset().top - 125)
                    }, 100);
                  }
                });
                if ($(window).width() <= 1024) {
                  $(".path-rates-service-charges .mobile-rate-title").html('<h1>Rates & Services Charges</h1><p class="rate-bread">' + cityName + ' > ' + cookieTypeName + '</p>');
                } else {
                  $("#load-content").prepend('<h1>Rates & Services Charges</h1><p class="rate-bread">' + cityName + ' > ' + cookieTypeName + '</p>');
                }
              });
            }
          });
          $('#service-type-form', context).change(function () {
            var cookie = Cookies.get("radiocity");
            var cookieCityName = Cookies.get("radiocityName");
            var stype = $("input[name='ServiceType']:checked").val();
            var stypeID = $("input[name='ServiceType']:checked").attr('id');
            var stypeName = $("label[for='tax" + stype + "']").text();
            Cookies.set('radiotype', stype, {
              expires: 1,
              sameSite: 'secure'
            });
            Cookies.set('radiotypeName', stypeName, {
              expires: 1,
              sameSite: 'secure'
            });
            if (cookie) {
              $('#load-content').load('/rates-services/' + stype + '/' + cookie + ' .ajax-content', function () {
                $(document).foundation();
                $(".radio-accordion .accordion-title span.service").text(": " + stypeName);
                $(".title-wrapper .title-section button", context).on("click", function () {
                  $('.popup').hide('fast');
                  $(this).next(".popup").toggle();
                });
                $(".rate-accordion").on("down.zf.accordion", function (e) {
                  var thisheight = $('.accordion-content', this).height();
                  if (thisheight > 50) {
                    $('html, body').animate({
                      scrollTop: ($('.is-active .accordion-content', this).offset().top - 125)
                    }, 100);
                  }
                });
                if ($(window).width() <= 1024) {
                  $(".path-rates-service-charges .mobile-rate-title").html('<h1>Rates & Services Charges</h1><p class="rate-bread">' + cookieCityName + ' > ' + stypeName + '</p>');
                } else {
                  $("#load-content").prepend('<h1>Rates & Services Charges</h1><p class="rate-bread">' + cookieCityName + ' > ' + stypeName + '</p>');
                }
              });
            }
          });
        }
      };
})(jQuery, Drupal);